"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calendar, Clock, Code, User, ChevronRight } from "lucide-react";
export default function Hero() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: graphicRef,
    isVisible: isGraphicVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="184318" id="hero" className="relative w-full min-h-screen flex flex-col items-center pt-8 pb-24 px-4 sm:px-6 lg:px-8 bg-[#1A1A1A] overflow-hidden font-sans">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_center,_var(--tw-gradient-stops))] from-[#FF8C00]/10 via-[#1A1A1A] to-[#1A1A1A] pointer-events-none" />
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#FF8C00]/5 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-orange-600/5 rounded-full blur-[120px] pointer-events-none" />

      {}
      <div className="w-full max-w-7xl mx-auto flex justify-center sm:justify-start relative z-20 mb-12 sm:mb-20">
        <Link to="#" className="flex items-center gap-2 group">
          <div className="bg-white/5 p-2 rounded-xl backdrop-blur-sm border border-white/10 group-hover:bg-white/10 transition-colors">
            <Code className="size-6 text-[#FF8C00]" />
          </div>
          <span className="text-2xl font-bold text-white tracking-tight">
            Think Local SEO
          </span>
        </Link>
      </div>

      {}
      <div ref={headerRef} className={`relative z-10 flex flex-col items-center w-full max-w-4xl mx-auto text-center transition-all duration-1000 transform ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <Badge variant="outline" className="text-[#FF8C00] border-[#FF8C00]/30 bg-[#FF8C00]/10 mb-8 py-2 px-5 text-sm sm:text-base font-medium rounded-full backdrop-blur-sm">UK SOLE TRADER AND TRADESMEN EXCLUSIVE</Badge>

        <p className="text-lg sm:text-xl md:text-2xl text-slate-300 font-medium mb-6 max-w-2xl">Stop losing leads when you're "on the job".</p>

        <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white uppercase tracking-tight mb-10 leading-[1.1]">
          The Silent Operator <br className="hidden sm:block" />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#FF8C00] to-[#FFA500]">
            Recover Every Missed Call
          </span>
        </h1>

        <p className="text-lg sm:text-xl md:text-2xl text-slate-300 font-medium mb-6 max-w-2xl">
          The system that sends an instant WhatsApp to your missed calls.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8 mb-16">
          <Button asChild size="lg" className="rounded-full bg-gradient-to-r from-[#FF8C00] to-[#E67E00] hover:from-[#E67E00] hover:to-[#FF8C00] text-black border-0 shadow-[0_0_40px_-10px_rgba(255,140,0,0.4)] px-10 h-16 text-lg sm:text-xl font-bold transition-all duration-300 hover:scale-105 group">
            <Link to="/PricingPage">
              Secure Your Founder Spot
              <ChevronRight className="ml-2 size-5 group-hover:translate-x-1 transition-transform" />
            </Link>
          </Button>
          <Link to="/HomePage">
            <div className="flex flex-col items-center sm:items-start text-sm sm:text-base text-slate-300/80 space-y-2 bg-white/5 px-6 py-3 rounded-2xl backdrop-blur-sm border border-white/10">
              <span className="flex items-center gap-2">
                <SafeHydrate><Calendar className="size-4 text-[#FF8C00]" /></SafeHydrate> Launch: MAY12TH
              </span>
              <span className="flex items-center gap-2">
                <Clock className="size-4 text-[#FF8C00]" /> 24/7 Missed Call Recovery
              </span>
            </div>
          </Link>
        </div>

        {}
        <div className="flex flex-col items-center w-full mb-20">
          <p className="text-sm font-semibold text-slate-400/60 uppercase tracking-[0.2em] mb-6">Trusted by UK Trade Professionals and sole traders</p>
          <div className="flex flex-wrap justify-center items-center gap-8 sm:gap-12 opacity-80">
            {["Plumbers", "Electricians", "Gas Safe", "Builders", "Roofers", "Sole Traders"].map((company, i) => <span key={company} data-index={i} className="text-xl sm:text-2xl font-bold text-white/90 tracking-tight">
                {company}
              </span>)}
          </div>
        </div>
      </div>

      {}
      <div ref={graphicRef} className={`w-full max-w-6xl mx-auto relative z-10 px-4 sm:px-6 transition-all duration-1000 delay-300 transform ${isGraphicVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="relative rounded-[2rem] sm:rounded-[3rem] overflow-hidden bg-white/5 border border-white/10 backdrop-blur-2xl shadow-2xl shadow-black/50 p-2 sm:p-4 aspect-video sm:aspect-[21/9]">
          <div className="absolute inset-0 bg-gradient-to-br from-[#FF8C00]/10 to-orange-500/10 mix-blend-overlay z-10" />
          
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/uk_tradesman_working_generic_apparel.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/uk_tradesman_working_generic_apparel.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1615185/img/uk_tradesman_working_generic_apparel.png-wvc-sizes" alt="UK Trade Professional working in London" className="w-full h-full object-cover rounded-[1.5rem] sm:rounded-[2.5rem] relative z-0" loading="lazy" />

          {}
          <div className="absolute bottom-4 left-4 sm:bottom-10 sm:left-10 z-20 bg-[#1A1A1A]/90 backdrop-blur-xl border border-[#FF8C00]/30 rounded-2xl p-4 sm:p-5 shadow-2xl flex items-center gap-4 transform -rotate-2 hover:rotate-0 transition-transform duration-500">
            <div className="size-12 sm:size-14 rounded-full bg-gradient-to-br from-[#FF8C00] to-[#E67E00] flex items-center justify-center shadow-inner">
              <User className="size-6 sm:size-7 text-black" />
            </div>
            <div>
              <p className="text-xs sm:text-sm text-slate-400 font-semibold uppercase tracking-wider mb-0.5">
                UK Support
              </p>
              <p className="text-lg sm:text-xl font-bold text-white">
                Think Local SEO
              </p>
            </div>
          </div>
          
          {}
          <div className="absolute top-10 right-10 z-20 bg-white/10 backdrop-blur-md border border-white/20 rounded-full p-4 shadow-xl animate-bounce hidden sm:block">
            <Code className="size-8 text-[#FF8C00]" />
          </div>
        </div>
      </div>
    </section>;
}